import type { FC, PropsWithChildren } from 'react'
import { createContext } from 'react'

import { useLazyRrwebClient } from '@core/rrweb/hooks/useLazyRrwebClient'
import type { RrwebModule, RrwebPackerModule } from '@core/rrweb/types'

export const RrwebClientContext = createContext<{
  rrweb: RrwebModule | undefined
  packer: RrwebPackerModule | undefined
}>({
  rrweb: undefined,
  packer: undefined,
})

interface Props {
  /** Whether it should start lazy loading rrweb. */
  loadClient: boolean
}

/** Provides rrweb library when it is lazy loaded. */
export const RrwebClientProvider: FC<PropsWithChildren<Props>> = ({
  children,
  loadClient,
}) => {
  const { rrwebClient, rrwebPacker } = useLazyRrwebClient(loadClient)

  return (
    <RrwebClientContext.Provider
      value={{
        rrweb: rrwebClient,
        packer: rrwebPacker,
      }}
    >
      {children}
    </RrwebClientContext.Provider>
  )
}
